import * as React from "react";
import { ProgressBar } from "@fluentui/react-components";
import PropTypes from 'prop-types';

export const FluentProgress = ({ value, max, thickness = "large" }) => {
  return <ProgressBar value={value} max={max} thickness={thickness} />;
};

FluentProgress.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  thickness: PropTypes.string,
};